import React, { useState } from 'react';
import styled from 'styled-components';
import { ProgressBar } from 'antd-mobile';
import { ClockCircleOutline, PlayOutline, CheckCircleOutline } from 'antd-mobile-icons';
import { useNavigate } from 'react-router-dom';
import TextLightScroll from '../../components/texts/TextLightScroll';

const PracticeList = () => {
  const navigate = useNavigate();
  const [activeFilter, setActiveFilter] = useState('all');

  // 模拟随手一练数据
  const practices = [
    {
      id: 1,
      title: 'JavaScript基础语法挑战',
      description: '通过10道精选题目，快速检验你的JavaScript基础知识掌握程度。',
      type: 'quiz',
      category: '前端开发',
      difficulty: '初级',
      duration: 15,
      questions: 10,
      participants: 2341,
      averageScore: 85,
      tags: ['JavaScript', '基础语法', '变量', '函数'],
      thumbnail: 'https://images.unsplash.com/photo-1627398242454-45a1465c2479?w=300&h=200&fit=crop',
      status: 'available',
      bestScore: 0,
      attempts: 0,
      points: 100,
      streak: 0
    },
    {
      id: 2,
      title: 'Python数据结构速练',
      description: '15分钟掌握Python中列表、字典、集合等数据结构的核心操作。',
      type: 'coding',
      category: '后端开发',
      difficulty: '中级',
      duration: 20,
      questions: 8,
      participants: 1876,
      averageScore: 78,
      tags: ['Python', '数据结构', '列表', '字典'],
      thumbnail: 'https://images.unsplash.com/photo-1526379095098-d400fd0bf935?w=300&h=200&fit=crop',
      status: 'completed',
      bestScore: 92,
      attempts: 3,
      points: 150,
      streak: 2
    },
    {
      id: 3,
      title: 'CSS布局技巧实战',
      description: '通过实际案例练习Flexbox和Grid布局，提升前端布局技能。',
      type: 'practice',
      category: '前端开发',
      difficulty: '中级',
      duration: 25,
      questions: 6,
      participants: 1543,
      averageScore: 82,
      tags: ['CSS', 'Flexbox', 'Grid', '布局'],
      thumbnail: 'https://images.unsplash.com/photo-1633356122544-f134324a6cee?w=300&h=200&fit=crop',
      status: 'in_progress',
      bestScore: 76,
      attempts: 1,
      points: 120,
      streak: 1
    },
    {
      id: 4,
      title: 'SQL查询语句练习',
      description: '通过真实数据库场景，练习各种SQL查询语句的编写技巧。',
      type: 'coding',
      category: '数据库',
      difficulty: '中级',
      duration: 30,
      questions: 12,
      participants: 987,
      averageScore: 75,
      tags: ['SQL', '查询', '数据库', 'JOIN'],
      thumbnail: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=300&h=200&fit=crop',
      status: 'available',
      bestScore: 0,
      attempts: 0,
      points: 180,
      streak: 0
    },
    {
      id: 5,
      title: '算法思维训练营',
      description: '经典算法题目精选，提升逻辑思维和问题解决能力。',
      type: 'algorithm',
      category: '算法',
      difficulty: '高级',
      duration: 45,
      questions: 5,
      participants: 654,
      averageScore: 68,
      tags: ['算法', '数据结构', '动态规划', '贪心'],
      thumbnail: 'https://images.unsplash.com/photo-1518186285589-2f7649de83e0?w=300&h=200&fit=crop',
      status: 'locked',
      bestScore: 0,
      attempts: 0,
      points: 250,
      streak: 0,
      requirement: '需要完成3个中级练习'
    },
    {
      id: 6,
      title: 'React Hooks实战',
      description: '深入理解React Hooks的使用场景和最佳实践。',
      type: 'practice',
      category: '前端开发',
      difficulty: '高级',
      duration: 35,
      questions: 8,
      participants: 432,
      averageScore: 71,
      tags: ['React', 'Hooks', 'useState', 'useEffect'],
      thumbnail: 'https://images.unsplash.com/photo-1555066931-4365d14bab8c?w=300&h=200&fit=crop',
      status: 'available',
      bestScore: 0,
      attempts: 0,
      points: 200,
      streak: 0
    },
    {
      id: 7,
      title: '数据分析快速入门',
      description: '使用Python进行数据清洗、分析和可视化的基础练习。',
      type: 'practice',
      category: '数据科学',
      difficulty: '初级',
      duration: 20,
      questions: 10,
      participants: 1234,
      averageScore: 88,
      tags: ['Python', 'Pandas', '数据分析', '可视化'],
      thumbnail: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=300&h=200&fit=crop',
      status: 'completed',
      bestScore: 95,
      attempts: 2,
      points: 130,
      streak: 3
    },
    {
      id: 8,
      title: 'Git版本控制实操',
      description: '掌握Git的基本操作和团队协作工作流程。',
      type: 'practice',
      category: '开发工具',
      difficulty: '初级',
      duration: 18,
      questions: 12,
      participants: 2156,
      averageScore: 91,
      tags: ['Git', '版本控制', '分支', '合并'],
      thumbnail: 'https://images.unsplash.com/photo-1556075798-4825dfaaf498?w=300&h=200&fit=crop',
      status: 'available',
      bestScore: 0,
      attempts: 0,
      points: 110,
      streak: 0
    }
  ];

  const filters = [
    { key: 'all', label: '全部练习', count: practices.length },
    { key: 'available', label: '可练习', count: practices.filter(p => p.status === 'available').length },
    { key: 'completed', label: '已完成', count: practices.filter(p => p.status === 'completed').length },
    { key: 'in_progress', label: '进行中', count: practices.filter(p => p.status === 'in_progress').length }
  ];

  const categories = [
    { key: 'all', label: '全部分类' },
    { key: '前端开发', label: '前端开发' },
    { key: '后端开发', label: '后端开发' },
    { key: '数据科学', label: '数据科学' },
    { key: '算法', label: '算法' },
    { key: '数据库', label: '数据库' },
    { key: '开发工具', label: '开发工具' }
  ];

  const [activeCategory, setActiveCategory] = useState('all');

  const filteredPractices = practices.filter(practice => {
    const statusMatch = activeFilter === 'all' || practice.status === activeFilter;
    const categoryMatch = activeCategory === 'all' || practice.category === activeCategory;
    return statusMatch && categoryMatch;
  });

  const getDifficultyColor = (difficulty: string) => {
    const colors: { [key: string]: string } = {
      '初级': '#4CAF50',
      '中级': '#FF9800',
      '高级': '#F44336'
    };
    return colors[difficulty] || '#666';
  };

  const getTypeIcon = (type: string) => {
    const icons: { [key: string]: React.ReactNode } = {
      'quiz': '📝',
      'coding': '💻',
      'practice': '🛠️',
      'algorithm': '🧮'
    };
    return icons[type] || '📚';
  };

  const getStatusColor = (status: string) => {
    const colors: { [key: string]: string } = {
      'available': '#4CAF50',
      'completed': '#2196F3',
      'in_progress': '#FF9800',
      'locked': '#9E9E9E'
    };
    return colors[status] || '#666';
  };

  const getStatusText = (status: string) => {
    const texts: { [key: string]: string } = {
      'available': '可开始',
      'completed': '已完成',
      'in_progress': '进行中',
      'locked': '已锁定'
    };
    return texts[status] || '未知';
  };

  const totalPoints = practices.reduce((sum, p) => sum + (p.status === 'completed' ? p.points : 0), 0);
  const completedCount = practices.filter(p => p.status === 'completed').length;
  const currentStreak = Math.max(...practices.map(p => p.streak));

  return (
    <StyledWrapper>
      <div className="practice-list-container">
        <div className="header">
          <div className="title-section">
            <TextLightScroll text="随手一练" />
            <p>利用碎片时间，通过精心设计的练习题目快速提升技能</p>
          </div>
          
          <div className="stats-section">
            <div className="stat-item">
              <span className="stat-number">{totalPoints}</span>
              <span className="stat-label">总积分</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">{completedCount}</span>
              <span className="stat-label">已完成</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">{currentStreak}</span>
              <span className="stat-label">连击数</span>
            </div>
          </div>
        </div>

        {/* 每日挑战卡片 */}
        <div className="daily-challenge">
          <div className="challenge-content">
            <div className="challenge-icon">🔥</div>
            <div className="challenge-info">
              <h3>今日挑战</h3>
              <p>完成3个练习获得额外50积分奖励</p>
              <ProgressBar percent={completedCount >= 3 ? 100 : (completedCount / 3) * 100} />
              <span className="progress-text">{completedCount}/3 已完成</span>
            </div>
            <button className="challenge-btn">
              {completedCount >= 3 ? '已完成' : '开始挑战'}
            </button>
          </div>
        </div>

        {/* 筛选器 */}
        <div className="filters-section">
          <div className="status-filters">
            {filters.map(filter => (
              <button
                key={filter.key}
                className={`filter-btn ${activeFilter === filter.key ? 'active' : ''}`}
                onClick={() => setActiveFilter(filter.key)}
              >
                {filter.label}
                <span className="count">({filter.count})</span>
              </button>
            ))}
          </div>
          
          <div className="category-filters">
            {categories.map(category => (
              <button
                key={category.key}
                className={`category-btn ${activeCategory === category.key ? 'active' : ''}`}
                onClick={() => setActiveCategory(category.key)}
              >
                {category.label}
              </button>
            ))}
          </div>
        </div>

        {/* 练习列表 */}
        <div className="practices-grid">
          {filteredPractices.map(practice => (
            <div 
              key={practice.id} 
              className={`practice-card ${practice.status}`}
              onClick={() => {
                if (practice.status !== 'locked') {
                  navigate(`/learn/practice/${practice.id}`);
                }
              }}
            >
              {/* 状态标签 */}
              <div className="status-badges">
                <div 
                  className="status-badge"
                  style={{ backgroundColor: getStatusColor(practice.status) }}
                >
                  {getStatusText(practice.status)}
                </div>
                {practice.streak > 0 && (
                  <div className="streak-badge">
                    🔥 {practice.streak}
                  </div>
                )}
              </div>
              
              {/* 练习缩略图 */}
              <div className="practice-thumbnail">
                <img src={practice.thumbnail} alt={practice.title} />
                <div className="practice-overlay">
                  <div className="play-button">
                    <PlayOutline />
                  </div>
                  <div className="type-badge">{getTypeIcon(practice.type)}</div>
                </div>
                {practice.status === 'locked' && (
                  <div className="locked-overlay">
                    <span className="lock-icon">🔒</span>
                  </div>
                )}
              </div>
              
              {/* 练习信息 */}
              <div className="practice-content">
                <div className="practice-header">
                  <h3 className="practice-title">{practice.title}</h3>
                  <div className="practice-meta">
                    <span className="category">{practice.category}</span>
                    <span 
                      className="difficulty" 
                      style={{ color: getDifficultyColor(practice.difficulty) }}
                    >
                      {practice.difficulty}
                    </span>
                  </div>
                </div>
                
                <p className="practice-description">{practice.description}</p>
                
                {practice.status === 'locked' && practice.requirement && (
                  <div className="requirement-notice">
                    <span className="requirement-text">🔒 {practice.requirement}</span>
                  </div>
                )}
                
                {/* 练习标签 */}
                <div className="practice-tags">
                  {practice.tags.slice(0, 3).map((tag, index) => (
                    <span key={index} className="tag">{tag}</span>
                  ))}
                  {practice.tags.length > 3 && (
                    <span className="more-tags">+{practice.tags.length - 3}</span>
                  )}
                </div>
                
                {/* 练习统计 */}
                <div className="practice-stats">
                  <div className="stat">
                    <ClockCircleOutline />
                    <span>{practice.duration}分钟</span>
                  </div>
                  <div className="stat">
                    <span>📋</span>
                    <span>{practice.questions}题</span>
                  </div>
                  <div className="stat">
                    <span>👥</span>
                    <span>{practice.participants}人参与</span>
                  </div>
                  <div className="stat">
                    <span>🏆</span>
                    <span>{practice.points}积分</span>
                  </div>
                </div>
                
                {/* 个人成绩 */}
                {practice.bestScore > 0 && (
                  <div className="personal-score">
                    <div className="score-info">
                      <span className="label">最佳成绩:</span>
                      <span className="score">{practice.bestScore}分</span>
                    </div>
                    <div className="attempts-info">
                      <span className="attempts">已练习{practice.attempts}次</span>
                    </div>
                  </div>
                )}
                
                {/* 平均分数 */}
                <div className="average-score">
                  <span className="label">平均分:</span>
                  <span className="score">{practice.averageScore}分</span>
                </div>
                
                {/* 操作按钮 */}
                <div className="practice-footer">
                  <button 
                    className="practice-btn"
                    disabled={practice.status === 'locked'}
                    onClick={(e) => {
                      e.stopPropagation();
                      if (practice.status !== 'locked') {
                        navigate(`/learn/practice/${practice.id}`);
                      }
                    }}
                  >
                    {practice.status === 'locked' ? (
                      '🔒 已锁定'
                    ) : practice.status === 'completed' ? (
                      <><CheckCircleOutline /> 重新练习</>
                    ) : practice.status === 'in_progress' ? (
                      <><PlayOutline /> 继续练习</>
                    ) : (
                      <><PlayOutline /> 开始练习</>
                    )}
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
        
        {filteredPractices.length === 0 && (
          <div className="empty-state">
            <div className="empty-icon">🎯</div>
            <h3>暂无练习内容</h3>
            <p>请尝试调整筛选条件或稍后再来</p>
            <button className="empty-btn" onClick={() => {
              setActiveFilter('all');
              setActiveCategory('all');
            }}>
              查看全部练习
            </button>
          </div>
        )}
      </div>
    </StyledWrapper>
  );
};

const StyledWrapper = styled.div`
  .practice-list-container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 24px;
    color: #1a1a1a;
  }

  .header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 32px;
    position: relative;
    
    @media (max-width: 768px) {
      flex-direction: column;
      gap: 20px;
    }
  }

  .title-section {
    p {
      font-size: 1rem;
      color: #666;
      margin: 0;
      line-height: 1.5;
      padding-top: 8px;
    }
  }

  .stats-section {
    display: flex;
    gap: 30px;
    
    @media (max-width: 768px) {
      gap: 20px;
    }
  }

  .stat-item {
    text-align: center;
    
    .stat-number {
      display: block;
      font-size: 2rem;
      font-weight: bold;
      color: #FFD700;
      line-height: 1;
    }
    
    .stat-label {
      font-size: 0.9rem;
      opacity: 0.8;
      margin-top: 5px;
    }
  }

  .daily-challenge {
    background: rgba(255, 255, 255, 0.8);
    backdrop-filter: blur(20px);
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 16px;
    margin-bottom: 32px;
    padding: 24px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  }

  .challenge-content {
    display: flex;
    align-items: center;
    gap: 20px;
    
    .challenge-icon {
      font-size: 3rem;
      flex-shrink: 0;
    }
    
    .challenge-info {
      flex: 1;
      
      h3 {
        margin: 0 0 8px 0;
        font-size: 1.3rem;
        color: #1a1a1a;
        font-weight: 600;
      }
      
      p {
        margin: 0 0 12px 0;
        color: #666;
      }
      
      .progress-text {
        font-size: 0.875rem;
        color: #666;
        margin-top: 8px;
        display: block;
      }
    }
  }

  .challenge-btn {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    border: none;
    padding: 12px 24px;
    border-radius: 12px;
    font-size: 0.875rem;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s ease;
    
    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 8px 25px rgba(102, 126, 234, 0.3);
    }
    
    &:active {
      transform: translateY(0);
    }
  }

  .filters-section {
    margin-bottom: 30px;
  }

  .status-filters {
    display: flex;
    gap: 10px;
    margin-bottom: 15px;
    flex-wrap: wrap;
  }

  .category-filters {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
  }

  .filter-btn,
  .category-btn {
    background: rgba(255, 255, 255, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.2);
    color: white;
    padding: 8px 16px;
    border-radius: 20px;
    cursor: pointer;
    transition: all 0.3s ease;
    font-size: 0.9rem;
    display: flex;
    align-items: center;
    gap: 5px;
    
    &:hover {
      background: rgba(255, 255, 255, 0.2);
      transform: translateY(-2px);
    }
    
    &.active {
      background: rgba(255, 215, 0, 0.2);
      border-color: #FFD700;
      color: #FFD700;
    }
    
    .count {
      font-size: 0.8rem;
      opacity: 0.8;
    }
  }

  .category-btn {
    padding: 6px 12px;
    font-size: 0.8rem;
  }

  .practices-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
    gap: 24px;
    
    @media (max-width: 768px) {
      grid-template-columns: 1fr;
    }
  }

  .practice-card {
    background: rgba(255, 255, 255, 0.8);
    backdrop-filter: blur(20px);
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 16px;
    overflow: hidden;
    cursor: pointer;
    transition: all 0.3s ease;
    position: relative;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
    
    &:hover {
      transform: translateY(-8px);
      box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);
      
      .practice-overlay {
        opacity: 1;
      }
    }
    
    &.locked {
      opacity: 0.6;
      cursor: not-allowed;
      
      &:hover {
        transform: none;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
      }
    }
  }

  .status-badges {
    position: absolute;
    top: 12px;
    right: 12px;
    z-index: 3;
    display: flex;
    gap: 8px;
    align-items: center;
  }

  .status-badge {
    color: white;
    padding: 6px 12px;
    border-radius: 20px;
    font-size: 0.75rem;
    font-weight: 500;
    backdrop-filter: blur(10px);
  }

  .streak-badge {
    background: rgba(255, 87, 34, 0.9);
    color: white;
    padding: 4px 8px;
    border-radius: 12px;
    font-size: 0.75rem;
    display: flex;
    align-items: center;
    gap: 3px;
    backdrop-filter: blur(10px);
  }

  .practice-thumbnail {
    position: relative;
    height: 200px;
    overflow: hidden;
    
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      transition: transform 0.3s ease;
    }
    
    &:hover img {
      transform: scale(1.1);
    }
  }

  .practice-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(135deg, rgba(102, 126, 234, 0.8) 0%, rgba(118, 75, 162, 0.8) 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    transition: all 0.3s ease;
    
    .play-button {
      background: rgba(255, 255, 255, 0.2);
      border: 2px solid white;
      border-radius: 50%;
      width: 60px;
      height: 60px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: white;
      font-size: 24px;
      backdrop-filter: blur(10px);
    }
    
    .type-badge {
      position: absolute;
      top: 12px;
      left: 12px;
      background: rgba(0, 0, 0, 0.7);
      color: white;
      padding: 6px 12px;
      border-radius: 20px;
      font-size: 0.75rem;
      backdrop-filter: blur(10px);
    }
  }

  .locked-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.6);
    display: flex;
    align-items: center;
    justify-content: center;
    
    .lock-icon {
      font-size: 2rem;
    }
  }

  .practice-content {
    padding: 20px;
    background: rgba(255, 255, 255, 0.9);
    backdrop-filter: blur(20px);
  }

  .practice-header {
    margin-bottom: 12px;
    
    .practice-title {
      font-size: 1.2rem;
      font-weight: 600;
      margin: 0 0 8px 0;
      line-height: 1.3;
      color: #1a1a1a;
    }
    
    .practice-meta {
      display: flex;
      gap: 12px;
      
      .category {
        background: rgba(103, 126, 234, 0.1);
        color: #667eea;
        padding: 4px 8px;
        border-radius: 8px;
        font-size: 0.75rem;
        font-weight: 500;
      }
      
      .difficulty {
        font-size: 0.8rem;
        font-weight: 600;
        color: #666;
      }
    }
  }

  .practice-description {
    font-size: 0.9rem;
    line-height: 1.6;
    color: #666;
    margin-bottom: 16px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .requirement-notice {
    background: rgba(158, 158, 158, 0.2);
    border: 1px solid rgba(158, 158, 158, 0.3);
    border-radius: 8px;
    padding: 10px;
    margin-bottom: 15px;
    
    .requirement-text {
      font-size: 0.8rem;
      color: #9E9E9E;
    }
  }

  .practice-tags {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
    margin-bottom: 16px;
    align-items: center;
    
    .tag {
      background: rgba(102, 126, 234, 0.1);
      color: #667eea;
      padding: 4px 8px;
      border-radius: 12px;
      font-size: 0.75rem;
      font-weight: 500;
    }
    
    .more-tags {
      font-size: 0.75rem;
      color: #667eea;
      background: rgba(102, 126, 234, 0.1);
      padding: 4px 8px;
      border-radius: 12px;
      font-weight: 500;
    }
  }

  .practice-stats {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px;
    margin-bottom: 16px;
    
    .stat {
      display: flex;
      align-items: center;
      gap: 6px;
      font-size: 0.8rem;
      color: #666;
    }
  }

  .personal-score {
    background: rgba(76, 175, 80, 0.2);
    border: 1px solid rgba(76, 175, 80, 0.3);
    border-radius: 8px;
    padding: 10px;
    margin-bottom: 10px;
    
    .score-info {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 5px;
      
      .label {
        font-size: 0.8rem;
        opacity: 0.9;
      }
      
      .score {
        font-weight: 600;
        color: #4CAF50;
      }
    }
    
    .attempts-info {
      .attempts {
        font-size: 0.75rem;
        opacity: 0.8;
      }
    }
  }

  .average-score {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
    font-size: 0.9rem;
    
    .label {
      opacity: 0.8;
    }
    
    .score {
      font-weight: 600;
      color: #FFD700;
    }
  }

  .practice-footer {
    margin-top: 16px;
    padding-top: 16px;
    border-top: 1px solid rgba(0, 0, 0, 0.1);
  }

  .practice-btn {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    border: none;
    padding: 12px 24px;
    border-radius: 12px;
    font-size: 0.875rem;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s ease;
    width: 100%;
    
    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 8px 25px rgba(102, 126, 234, 0.3);
    }
    
    &:active {
      transform: translateY(0);
    }
    
    &:disabled {
      background: #ccc;
      cursor: not-allowed;
      transform: none;
      box-shadow: none;
    }
  }

  .empty-state {
    text-align: center;
    padding: 60px 20px;
    color: white;
    
    .empty-icon {
      font-size: 4rem;
      margin-bottom: 20px;
    }
    
    h3 {
      font-size: 1.5rem;
      margin-bottom: 10px;
    }
    
    p {
      opacity: 0.8;
      margin-bottom: 25px;
    }
  }
`;

export default PracticeList;